import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const ArrowDown2 = ({ size, color, theme, iconTitle }) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg
      viewBox="0 0 17 9"
      width={size}
      height={size}
      color={iconColor}
      fill={iconColor}
    >
      <title>{iconTitle}</title>
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <path
          d="M8.49987082,-1.77635684e-15 L0.326861278,7.29532083 C-0.0813386995,7.65886282 -0.111278698,8.27913581 0.260001281,8.6789338 C0.630271261,9.07971079 1.26104123,9.10910779 1.6692412,8.7455668 L8.49987082,2.64865694 L15.3305104,8.7455668 C15.7377104,9.10910779 16.3704804,9.07971079 16.7407504,8.6789338 C17.1110303,8.27913581 17.0810803,7.65886282 16.6738804,7.29532083 L8.49987082,-1.77635684e-15 Z"
          fill="#A28352"
          transform="translate(8.500000, 4.500000) scale(-1, 1) rotate(-180.000000) translate(-8.500000, -4.500000) "
        ></path>
      </g>
    </svg>
  );
};

ArrowDown2.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

ArrowDown2.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(ArrowDown2);
